export const normalizarDocumento = (v: string | null | undefined): string =>
  String(v ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '')

export function cpfValido(d: string): boolean {
  if (!/^\d{11}$/.test(d) || /^(\d)\1{10}$/.test(d)) return false
  const dv = (n: number): number => {
    let soma = 0
    for (let i = 0; i < n; i++) soma += Number(d[i]) * (n + 1 - i)
    const resto = soma % 11
    return resto < 2 ? 0 : 11 - resto
  }
  return dv(9) === Number(d[9]) && dv(10) === Number(d[10])
}

const PESOS_CNPJ = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

export function cnpjValido(c: string): boolean {
  if (!/^[0-9A-Z]{12}\d{2}$/.test(c) || /^(.)\1{13}$/.test(c)) return false
  const dv = (n: number): number => {
    const pesos = PESOS_CNPJ.slice(13 - n)
    let soma = 0
    for (let i = 0; i < n; i++) soma += (c.charCodeAt(i) - 48) * pesos[i]
    const resto = soma % 11
    return resto < 2 ? 0 : 11 - resto
  }
  return dv(12) === Number(c[12]) && dv(13) === Number(c[13])
}

export const documentoValido = (v: string | null | undefined): boolean => {
  const d = normalizarDocumento(v)
  return d.length === 11 ? cpfValido(d) : d.length === 14 ? cnpjValido(d) : false
}

export function mascaraDocumento(v: string): string {
  const d = normalizarDocumento(v).slice(0, 14)
  if (d.length <= 11 && /^\d*$/.test(d)) {
    return d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1-$2')
  }
  return d.replace(/^(.{2})(.)/, '$1.$2').replace(/^(.{2})\.(.{3})(.)/, '$1.$2.$3')
    .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, '$1.$2.$3/$4').replace(/\/(.{4})(.)/, '/$1-$2')
}

export const exibirDocumento = (v: string | null | undefined): string => {
  const s = String(v ?? '').trim()
  if (!s) return '—'
  return s.indexOf('•') >= 0 ? s : mascaraDocumento(s)
}

export const impedimentoDocumento = (v: string | null | undefined, obrigatorio: boolean): string | null => {
  const d = normalizarDocumento(v)
  if (!d) return obrigatorio ? 'Informe o CPF ou o CNPJ.' : null
  return documentoValido(d) ? null : 'CPF ou CNPJ inválido: confira os dígitos.'
}
